import {createSelector, MemoizedSelector} from '@ngrx/store';
import {getResultCodesState} from '@app/store/faxe/faxe-selectors';
import {ResultCode} from '@app/rest-client/faxe/models/result-code';
import {selectAllResultCode} from '@app/store/faxe/results-code/result-code.reducer';

export const selectResultCodeAll: MemoizedSelector<object, ResultCode[]> = createSelector(
  getResultCodesState,
  selectAllResultCode
);

export const selectResultCode = ():
  MemoizedSelector<object, ResultCode[]> =>
  createSelector(
    getResultCodesState,
    selectResultCodeAll,
    (state, all) => all
  );



